(function() {
  'use strict';

  // Initialize Lucide icons
  function initIcons() {
    if (typeof lucide !== 'undefined') {
      lucide.createIcons();
    }
  }

  // Mobile navigation toggle
  function initMobileNav() {
    var mobileMenu = document.getElementById('mobile-menu');
    if (!mobileMenu) return;

    var background = ['#main-content', '#shopify-section-footer', '[data-announcement-bar]']
      .map(function (s) { return document.querySelector(s); })
      .filter(Boolean);
    var lastFocus = null;

    function focusables() {
      return mobileMenu.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
    }

    function openMenu() {
      lastFocus = document.activeElement;
      mobileMenu.style.display = 'flex';
      mobileMenu.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
      background.forEach(function (el) { el.setAttribute('inert', ''); });
      var first = focusables()[0];
      setTimeout(function () { (first || mobileMenu).focus(); }, 30);
    }

    function closeMenu() {
      mobileMenu.style.display = 'none';
      mobileMenu.classList.add('hidden');
      document.body.style.overflow = '';
      background.forEach(function (el) { el.removeAttribute('inert'); });
      if (lastFocus && document.body.contains(lastFocus)) lastFocus.focus();
    }

    document.querySelectorAll('[data-mobile-menu-toggle]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var shouldOpen = this.getAttribute('data-mobile-menu-toggle') === 'true';
        if (shouldOpen) { openMenu(); } else { closeMenu(); }
      });
    });

    mobileMenu.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', closeMenu);
    });

    document.addEventListener('keydown', function(e) {
      if (mobileMenu.classList.contains('hidden')) return;
      if (e.key === 'Escape') { closeMenu(); return; }
      if (e.key !== 'Tab') return;
      var els = focusables();
      if (!els.length) return;
      var first = els[0], last = els[els.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  // Mobile filter toggle (collection page)
  function initMobileFilters() {
    var filterBtn = document.querySelector('[data-mobile-filter-toggle]');
    var filterSidebar = document.querySelector('[data-filter-sidebar]');
    if (!filterBtn || !filterSidebar) return;

    filterBtn.addEventListener('click', function(e) {
      e.preventDefault();
      filterSidebar.classList.toggle('hidden');
    });
  }

  // Accordion
  function initAccordion() {
    document.querySelectorAll('[data-accordion]').forEach(accordion => {
      const triggers = accordion.querySelectorAll('[data-accordion-trigger]');

      triggers.forEach(trigger => {
        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          const content = this.nextElementSibling;

          if (!content || !content.hasAttribute('data-accordion-content')) return;

          const isOpen = content.style.maxHeight && content.style.maxHeight !== '0px';

          if (isOpen) {
            content.style.maxHeight = '0';
            this.setAttribute('aria-expanded', 'false');
            const icon = this.querySelector('[data-accordion-icon]');
            if (icon) icon.textContent = '+';
          } else {
            content.style.maxHeight = content.scrollHeight + 'px';
            this.setAttribute('aria-expanded', 'true');
            const icon = this.querySelector('[data-accordion-icon]');
            if (icon) icon.textContent = '−';
          }
        });
      });
    });
  }

  // Cart quantity AJAX
  function initCartQuantity() {
    document.addEventListener('click', function(e) {
      const minusBtn = e.target.closest('[data-quantity-minus]');
      const plusBtn = e.target.closest('[data-quantity-plus]');

      if (!minusBtn && !plusBtn) return;

      e.preventDefault();

      const container = (minusBtn || plusBtn).closest('[data-quantity-container]');
      if (!container) return;

      const input = container.querySelector('[data-quantity-input]');
      const lineKey = container.getAttribute('data-line-item-key');

      if (!input || !lineKey) return;

      let quantity = parseInt(input.value, 10);

      if (minusBtn) quantity = Math.max(0, quantity - 1);
      if (plusBtn) quantity = quantity + 1;

      if (quantity === 0) {
        // Remove item
        updateCartItem(lineKey, 0);
      } else {
        input.value = quantity;
        updateCartItem(lineKey, quantity);
      }
    });
  }

  // Cart remove
  function initCartRemove() {
    document.addEventListener('click', function(e) {
      const removeLink = e.target.closest('[data-cart-remove]');
      if (!removeLink) return;

      e.preventDefault();
      const lineKey = removeLink.getAttribute('data-line-item-key');
      if (lineKey) {
        updateCartItem(lineKey, 0);
      }
    });
  }

  // Helper: Update cart item via AJAX
  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        line: key,
        quantity: quantity,
      }),
    })
      .then(response => response.json())
      .then(() => {
        // Reload page to reflect changes
        window.location.reload();
      })
      .catch(error => {
        console.error('Cart update error:', error);
        alert('Error updating cart. Please try again.');
      });
  }

  // Promo code toggle
  function initPromoToggle() {
    const toggleBtn = document.querySelector('[data-promo-toggle]');
    const promoForm = document.querySelector('[data-promo-form]');

    if (!toggleBtn || !promoForm) return;

    toggleBtn.addEventListener('click', function(e) {
      e.preventDefault();
      const isHidden = promoForm.classList.contains('hidden');

      if (isHidden) {
        promoForm.classList.remove('hidden');
        const icon = toggleBtn.querySelector('[data-promo-icon]');
        if (icon) icon.textContent = '−';
      } else {
        promoForm.classList.add('hidden');
        const icon = toggleBtn.querySelector('[data-promo-icon]');
        if (icon) icon.textContent = '+';
      }
    });
  }

  // Newsletter form
  function initNewsletter() {
    document.querySelectorAll('[data-newsletter-form]').forEach(form => {
      let isSubmitting = false;

      form.addEventListener('submit', function(e) {
        if (isSubmitting) {
          e.preventDefault();
          return;
        }

        isSubmitting = true;
        const submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.setAttribute('aria-busy', 'true');
        }

        // Re-enable after 2 seconds
        setTimeout(() => {
          isSubmitting = false;
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.removeAttribute('aria-busy');
          }
        }, 2000);
      });
    });
  }

  // Initialize on DOM ready
  document.addEventListener('DOMContentLoaded', function() {
    initIcons();
    initMobileNav();
    initMobileFilters();
    initAccordion();
    initCartQuantity();
    initCartRemove();
    initPromoToggle();
    initNewsletter();
  });

  // Re-initialize icons after Shopify section loads
  document.addEventListener('shopify:section:load', function() {
    initIcons();
    initAccordion();
    initCartQuantity();
    initCartRemove();
    initPromoToggle();
  });
})();
